// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_23LnaF58_2GQCu6pwDaPkY","filter":"Io5hOwVn01Bi0Gj_YMTdM","input-wrapper":"_3LXAUhNJFQMqEZS2p68vpv"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Journal/components/FilterPrompts.mod.css
// module id = 1799
// module chunks = 0